import { Box } from '@chakra-ui/react'
import { useAuth } from '../context/AuthContext'

import { useLogout } from 'BrokerTsLib/src/hooks/useAccount'
import { User } from '../icons'
import { MenuGroup } from './Menu/MenuGroup'
import { MenuItem } from './Menu/MenuItem'

export const BaseMenu = () => {
  const { user } = useAuth() ?? {}

  const {logout, isLoggingOut} = useLogout()

  return (
    <Box
      sx={{
        display: { base: 'none', xl: 'grid' },
        width: '100%',
        gridAutoFlow: 'column',
        justifyContent: 'end'
      }}
      className="site-menu-wrapper"
    >
      <MenuGroup>
        <li>
          <MenuItem to="/profile">
            <User color="secondary.300" />
            {user?.userFullName}
          </MenuItem>
        </li>
        <li>
          <MenuItem as={'div'} onClick={() => logout()} isLoading={isLoggingOut}>
            Odhlásit se
          </MenuItem>
        </li>
      </MenuGroup>
    </Box>
  )
}
